import { render, staticRenderFns } from "./ShowPaystack.vue?vue&type=template&id=73d695f0&scoped=true&"
import script from "./ShowPaystack.vue?vue&type=script&lang=js&"
export * from "./ShowPaystack.vue?vue&type=script&lang=js&"
import style0 from "./ShowPaystack.vue?vue&type=style&index=0&id=73d695f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d695f0",
  null
  
)

export default component.exports